import React, { Component } from 'react'

import lockGrey from "../assets/img/lockGrey.png";

class Loader extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {
    return (
      <div className="loader-wrapper">
        <img src={lockGrey} alt="Cadenas : chargement" />
        <div id="loader"></div>
        <div className="loader-section-transparent section-left"></div>
        <div className="loader-section-transparent section-right"></div>
      </div>
    )
  }
}

export default Loader
